var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33268 5.66797V8.33464L7.99935 9.33464M6.33268 2.66797C3.20307 2.66797 0.666016 5.20502 0.666016 8.33464C0.666016 11.4642 3.20307 14.0013 6.33268 14.0013C9.4623 14.0013 11.9993 11.4642 11.9993 8.33464C11.9993 5.20502 9.4623 2.66797 6.33268 2.66797ZM6.33268 2.66797V0.667969M4.99935 0.667969H7.66602M11.8853 3.06266L10.8853 2.06266L11.3853 2.56266M0.780029 3.06266L1.78003 2.06266L1.28003 2.56266",
    stroke: "#3D9F4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenClock);
export default __webpack_public_path__ + "static/media/green-clock.25b649f1eb5d00cb4655267dc9cf00bc.svg";
export { ForwardRef as ReactComponent };